import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useOutletContext } from "react-router-dom";
import userService from '../../services/UserService';
import NavUser from '../../components/user/NavUser';
import "./User.css";
import "../../static/css/alert.css";

export default function SettingsUser () {
    const { setAvatar, avatar } = useOutletContext(); // Ottieniamo avatar e setAvatar dal contesto
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [error, setError] = useState('');
    const [result, setResult] = useState('');

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            // Controlla la dimensione del file
            const maxSizeInKB = 100; // Limite di 100 KB
            if (selectedFile.size > maxSizeInKB * 1024) {
                alert("Il file è troppo grande. La dimensione massima è di 100 KB.");
                return;
            }
            // Converte il file in Base64
            const base64 = await fileToBase64(selectedFile);

            // Crea un oggetto FormData per inviare il file
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append("userId", localStorage.getItem("id_user"));

            userService.upload(formData)
            .then((res) => {
                if (res.status === 200) {
                    // Aggiorna l'avatar
                    localStorage.setItem("avatar", base64);
                    setAvatar(base64);
                    console.log(res);
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    // Funzione per convertire il file in Base64
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file); // Legge il file come Base64
        });
    };

    const onSubmitUser = async (data) => {
        userService.update(data)
        .then((res) => {
            if (res.status === 200) {
                const {name, address, comune, phone } = res.data;
                // Memorizza il JWT e i dati utente nel localStorage
                localStorage.setItem("name", name);
                localStorage.setItem("address", address);
                localStorage.setItem("comune", comune);
                localStorage.setItem("phone", phone);

                setResult('Dati aggiornati');
            }
        }).catch((error) => {
            if (error.status === 401)  {
                setError('Credenziali non valide');
            } else {
                setError("Errore durante l'aggiornamneto, riprovare");
                console.log(error);
            }
        });
    };

    useEffect(() => {
        // Recupera il dati dell'utente
        setValue('id_user', localStorage.getItem("id_user"));
        setValue('name', localStorage.getItem("name"));
        setValue('address', localStorage.getItem("address"));
        setValue('comune', localStorage.getItem("comune"));
        setValue('phone', localStorage.getItem("phone"));
    }, [setValue]);

  	return (
        <div className="row">
            <div className="col-md-12">
                {/* Nav User */}
                <NavUser />
                {/* Nav User */}
                {/* Form Account */}
                <div className="card mb-6">
                    <div className="card-body">
                        <div className="d-flex align-items-start align-items-sm-center gap-6 pb-4 border-bottom">
                            <img src={avatar} alt="user-avatar" className="d-block w-px-100 h-px-100 rounded" />
                            <div className="button-wrapper">
                                <label htmlFor="upload" className="btn btn-primary me-3 mb-4">
                                    <span className="d-none d-sm-block">Carica foto</span>
                                    <i className="bx bx-upload d-block d-sm-none"></i>
                                    <input hidden type="file"  onChange={handleFileChange} className={`account-file-input`}
                                        id="upload" placeholder="Carica foto" accept="image/png, image/jpeg"
                                    />
                                </label>
                                <div>Estensioni accettate JPG e PNG. Max dimensione 100K.</div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body pt-4">
                        {error && <div className="mb-6 text-center alert alert-outline-danger">{error}</div>}
                        {result && <div className="mb-6 text-center alert alert-outline-success">{result}</div>}
                        <form onSubmit={handleSubmit(onSubmitUser)}>
                            <input type="hidden" {...register('id_user')}/>
                            <div className="row g-6">
                                <div className="col-md-6">
                                    <label htmlFor="name" className="form-label">Nome Completo</label>
                                    <input type="text" className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                        placeholder="Nome Completo"
                                        {...register('name', { required: 'Inserisci il Nome' })}
                                    />
                                    {errors.name && <div className="invalid-input">{errors.name.message}</div>}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="phone" className="form-label">Telefono</label>
                                    <input className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                        type="text"
                                        placeholder="Telefono"
                                        {...register("phone", {
                                            required: "Inserisci il Telefono",
                                            pattern: {
                                              value: /^[+]?[0-9]{10,15}$/, // La regex che valida il numero di telefono
                                              message: 'Numero di telefono non valido' // Messaggio di errore personalizzato
                                            }
                                        })}
                                     />
                                     {errors.phone && <div className="invalid-input">{errors.phone.message}</div>}
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="address" className="form-label">Indirizzo</label>
                                    <input className="form-control"
                                        type="text"
                                        placeholder="Indirizzo"
                                        {...register("address")}
                                     />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="comune" className="form-label">Comune</label>
                                    <input className="form-control"
                                        type="text"
                                        placeholder="Comune"
                                        {...register("comune")}
                                     />
                                </div>
                            </div>
                            <div className="mt-6">
                              <button type="submit" className="btn btn-primary me-3">Salva</button>
                              <button type="reset" className="btn btn-label-secondary">Reset</button>
                            </div>
                        </form>
                    </div>
                </div>
             </div>
         </div>
	);
}